// import _ from "lodash";
import React from "react";
import { ROUTER_PATH } from "../../common/constant";
// import { IHomeBannerProps } from "../../models/interface";
import { localizeRouteKey } from "../../shared/helpers";
import "./style.scss";

const Banner = (props: any) => {
  const { sectionItem, history } = props;
  
  // const showSubImages = (data: any) => {
  //   return _.sortBy(data, ["order"]).map((item: any, i: number) => (
  //     <div
  //       className="container"
  //       onClick={() =>
  //         history.push(localizeRouteKey(ROUTER_PATH.TOPIC) + item?.url)
  //       }>
  //       <img key={i} src={item.images[0].galaries[0].path} alt="" />
  //       <div className="overlay">
  //         <span className="sub-title banner-title">{item.title}</span>
  //         <span className="main-content banner-content">{item.content}</span>
  //       </div>
  //     </div>
  //   ));
  // };

  const renderContent = () => {
    const gallery = sectionItem?.images?.[0].galaries?.[0]
    if (!gallery) {
      return null
    }
    if (gallery.mime == "video/mp4") {
      return <video autoPlay={"autoplay"} loop={true} muted={true} className={"banner-video"}>
        <source src={gallery.path} type="video/mp4" />
    {/* <img src={fallback.gif} width="400" height="300" /> */}
      </video>
    }
    return <img src={gallery.path} alt="" />
  }

  return sectionItem?.images && sectionItem?.images.length ? (
    <div className="kd-banner-wrap">
      <div
        className="kd-banner-1"
        onClick={() =>
          history.push(localizeRouteKey(ROUTER_PATH.TOPIC) + sectionItem?.url)
        }>
        {renderContent()}
      </div>
      {/* <div className="kd-banner-2">{showSubImages(sectionItem?.children)}</div> */}
    </div>
  ) : null;
};

export default Banner;
